import {
    GET_AMSTHREATS_LOADING,
    GET_AMSTHREATS_SUCCESS,
    GET_AMSTHREATS_FAILED,
  } from "../types";
  
  const initialState = {
    loading: false,
    error: null,
    threats: null,
  };
  
  export const amsThreatsReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
  ) => {
    switch (action.type) {
      case GET_AMSTHREATS_LOADING:
        return {
          ...state,
          loading: action.loading,
          error: null,
        };
      case GET_AMSTHREATS_SUCCESS:
        return {
          ...state,
          loading: false,
            threats : action.payload,
          error: null,
        };
      case GET_AMSTHREATS_FAILED:
        return {
          ...state,
          loading: false,
          error: action.error,
        };
       
      default:
        return state;
    }
  };
  